module.exports = __webpack_public_path__ + "img/mernagf.29f6242d.jpg";